// extracted by mini-css-extract-plugin
export default {"card":"CardVisitas_card__Tl7cl","container":"CardVisitas_container__BgYO7"};